var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "new_top2",
      staticStyle: {
        background: "#fff",
        width: "1002px",
        "border-bottom-color": "#91c0ec"
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "nt2_title", staticStyle: { left: "397px" } }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "nt2_goindex",
          staticStyle: { color: "#1d7a8e", "margin-right": "15px" },
          attrs: { to: "/", target: "_self" }
        },
        [_vm._v("网站首页")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "nt2_logo", staticStyle: { "padding-left": "15px" } },
      [
        _c("img", {
          attrs: {
            src: require("../assets/img/shiyan_logo.jpg"),
            width: "365",
            height: "74"
          }
        })
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c494178", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c494178","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header1.vue
// module id = null
// module chunks = 